(() => {
  const bootstrap = new AbortController();

  function install() {
    const app = window.ChefBlacklandApp;
    const launcherPolicy = app?.Launcher;
    const root = app?.elements?.root;
    const button = app?.elements?.launcher;
    if (!root?.isConnected || root.dataset.chefBlacklandInitialized !== 'true'
      || !button?.isConnected || typeof launcherPolicy?.evaluateScroll !== 'function'
      || typeof launcherPolicy?.handleScroll !== 'function'
      || typeof launcherPolicy?.scrollPosition !== 'function'
      || typeof launcherPolicy?.setInteracting !== 'function'
      || typeof launcherPolicy?.sync !== 'function'
      || typeof app.state?.launcherWantsCompact !== 'boolean') return;

    bootstrap.abort();
    if (root.dataset.blacklandLauncherAdaptive === 'true') return;
    root.dataset.blacklandLauncherAdaptive = 'true';

    const nearTop = 160;
    const movementThreshold = 12;
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const desktopScroll = window.matchMedia('(min-width: 990px)');
    const page = document.querySelector('.page-wrapper');
    const position = () => {
      const scroller = desktopScroll.matches && page ? page : document.scrollingElement;
      return Math.max(0, Math.min(scroller.scrollTop, scroller.scrollHeight - scroller.clientHeight));
    };
    const panelIsOpen = () => root.classList.contains('chef-blackland-root--open')
      || button.getAttribute('aria-expanded') === 'true';
    let lastY = position();
    let direction = 0;
    let travel = 0;
    let open = panelIsOpen();

    const sync = () => {
      if (position() <= nearTop) app.state.launcherWantsCompact = false;
      launcherPolicy.setInteracting(button.matches(':focus-visible')
        || (hover.matches && button.matches(':hover')));
    };

    launcherPolicy.scrollPosition = position;
    launcherPolicy.evaluateScroll = () => {
      const current = position();
      const delta = current - lastY;
      lastY = current;

      if (panelIsOpen()) {
        direction = 0;
        travel = 0;
        return;
      }

      if (current <= nearTop) {
        app.state.launcherWantsCompact = false;
        direction = 0;
        travel = 0;
      } else if (delta !== 0) {
        const nextDirection = Math.sign(delta);
        if (nextDirection !== direction) travel = 0;
        direction = nextDirection;
        travel += Math.abs(delta);
        if (travel >= movementThreshold) {
          app.state.launcherWantsCompact = direction > 0;
          travel = 0;
        }
      }
      sync();
    };

    page?.addEventListener('scroll', () => launcherPolicy.handleScroll(), { passive: true });
    desktopScroll.addEventListener('change', () => {
      lastY = position();
      direction = 0;
      travel = 0;
      sync();
    });

    new MutationObserver(() => {
      const nextOpen = panelIsOpen();
      if (nextOpen === open) return;
      open = nextOpen;
      lastY = position();
      direction = 0;
      travel = 0;
      sync();
    }).observe(root, { attributes: true, attributeFilter: ['class'] });

    app.state.launcherWantsCompact = false;
    sync();
  }

  document.addEventListener('DOMContentLoaded', install, { once: true, signal: bootstrap.signal });
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLScriptElement) install();
  }, { capture: true, signal: bootstrap.signal });
  window.addEventListener('load', install, { once: true, signal: bootstrap.signal });
  install();
})();
